import React, { createContext, useContext, useState, useCallback } from "react";

const DICT = {
  fr: {
    "app.name": "Colis2Go",
    "app.tagline": "Groupage aérien & maritime vers l'Afrique",
    "nav.search": "Rechercher",
    "nav.howItWorks": "Comment ça marche",
    "nav.partners": "Partenaires",
    "nav.login": "Connexion",
    "nav.register": "Inscription",
    "nav.dashboard": "Tableau de bord",
    "nav.logout": "Déconnexion",
    "nav.becomePartner": "Devenir partenaire",
    "hero.title": "Achetez où vous voulez. Expédiez vers l'Afrique.",
    "hero.subtitle": "Envoyez vos marchandises à votre adresse Colis2Go, comparez les prix, réservez et suivez vos expéditions par avion ou par bateau.",
    "search.originTitle": "Où se trouve votre marchandise ?",
    "search.destTitle": "Où voulez-vous l'envoyer ?",
    "search.country": "Pays",
    "search.city": "Ville",
    "search.mode": "Mode de transport",
    "search.air": "Aérien / Express",
    "search.sea": "Maritime",
    "search.all": "Tous",
    "search.cta": "Trouver un partenaire",
    "search.selectCountry": "Sélectionner un pays",
    "search.selectCity": "Toutes les villes",
    "results.title": "Partenaires disponibles",
    "results.none": "Aucun partenaire sur cette route pour le moment. Cette route n'est pas encore active.",
    "results.verified": "Partenaire vérifié",
    "results.shipments": "expéditions réalisées",
    "results.departures": "Départs",
    "results.delay": "Délai indicatif",
    "results.days": "jours",
    "results.viewProfile": "Voir la fiche",
    "results.book": "Réserver",
    "results.from": "à partir de",
    "partner.routes": "Routes desservies",
    "partner.reviews": "Avis vérifiés",
    "partner.about": "À propos",
    "partner.acceptedGoods": "Marchandises acceptées",
    "partner.forbiddenGoods": "Marchandises interdites",
    "partner.depotHours": "Horaires du dépôt",
    "partner.customs": "Dédouanement inclus",
    "partner.delivery": "Livraison finale incluse",
    "partner.yes": "Oui",
    "partner.no": "Non",
    "partner.requestQuote": "Demander un devis",
    "partner.book": "Réserver cette route",
    "auth.loginTitle": "Connexion",
    "auth.registerTitle": "Créer un compte",
    "auth.email": "Email",
    "auth.password": "Mot de passe",
    "auth.name": "Nom",
    "auth.role": "Je suis",
    "auth.customer": "Client",
    "auth.partner": "Partenaire de groupage",
    "auth.loginBtn": "Se connecter",
    "auth.registerBtn": "S'inscrire",
    "auth.google": "Continuer avec Google",
    "auth.facebook": "Continuer avec Facebook",
    "fb.linkPrompt": "Un compte Colis2Go existe déjà avec cet email. Connectez-vous avec votre méthode habituelle pour rattacher votre compte Facebook en toute sécurité.",
    "fb.linked": "Compte Facebook rattaché — vous pouvez désormais vous connecter avec Facebook.",
    "fb.noEmail": "Votre compte Facebook ne fournit pas d'adresse email. Créez un compte avec votre email, puis reconnectez-vous avec Facebook.",
    "fb.cancelled": "Connexion Facebook annulée.",
    "fb.error": "La connexion Facebook a échoué. Veuillez réessayer.",
    "auth.noAccount": "Pas encore de compte ?",
    "auth.hasAccount": "Déjà un compte ?",
    "auth.or": "ou",
    "dash.customer": "Espace Client",
    "dash.partner": "Espace Partenaire",
    "dash.admin": "Administration",
    "dash.myShipments": "Mes envois vers l'Afrique",
    "dash.myQuotes": "Mes devis",
    "dash.notifications": "Notifications",
    "dash.newSearch": "Nouvelle recherche",
    "dash.noShipments": "Aucune expédition pour l'instant.",
    "ship.reference": "Référence",
    "ship.status": "Statut",
    "ship.suppliers": "Fournisseurs",
    "ship.packages": "Colis reçus",
    "ship.addSupplier": "Ajouter un fournisseur",
    "ship.supplierName": "Nom du fournisseur",
    "ship.expectedCartons": "Cartons attendus",
    "ship.received": "Reçu",
    "ship.partial": "Partiel",
    "ship.pending": "En attente",
    "ship.consolidate": "Consolider et expédier",
    "ship.estimatedPrice": "Prix estimatif",
    "ship.estimatedNote": "Prix final après réception et vérification (poids réel, dimensions, quantité, CBM).",
    "ship.onQuote": "Sur devis — le prix final sera communiqué après réception et vérification au dépôt.",
    "ship.initialEstimate": "Estimation initiale :",
    "ship.afterVerification": "→ Prix final après vérification",
    "ship.finalPrice": "Prix final à valider",
    "ship.acceptFinal": "ACCEPTER LE PRIX FINAL",
    "ship.tracking": "Suivi de l'expédition",
    "ship.receivingAddress": "Adresse de réception",
    "ship.destination": "Destination",
    "ship.mode": "Mode",
    "ship.leaveReview": "Laisser un avis",
    "ship.cartons": "cartons",
    "partner.dash.newPackages": "Réception",
    "partner.dash.shipments": "Expéditions",
    "partner.dash.routes": "Routes & tarifs",
    "partner.dash.quotes": "Devis",
    "partner.dash.profile": "Profil",
    "partner.dash.receive": "Recevoir un colis",
    "partner.dash.scan": "Scanner / référence",
    "partner.dash.weight": "Poids (kg)",
    "partner.dash.dims": "Dimensions (cm)",
    "partner.dash.cartonsCount": "Nombre de cartons",
    "partner.dash.setFinal": "Calculer le prix final",
    "partner.dash.markShipped": "Marquer expédié",
    "partner.dash.markArrived": "Marquer arrivé",
    "partner.dash.markDelivered": "Marquer livré",
    "admin.stats": "Statistiques",
    "admin.partners": "Partenaires",
    "admin.users": "Utilisateurs",
    "admin.shipments": "Expéditions",
    "admin.geo": "Pays & villes",
    "admin.verify": "Vérifier",
    "admin.unverify": "Retirer vérif.",
    "admin.gmv": "Volume total (GMV)",
    "admin.commission": "Commission estimée",
    "common.save": "Enregistrer",
    "common.cancel": "Annuler",
    "common.add": "Ajouter",
    "common.send": "Envoyer",
    "common.close": "Fermer",
    "common.loading": "Chargement…",
    "common.back": "Retour",
    "protected.title": "Paiement protégé",
    "protected.desc": "Payez votre expédition sur la plateforme. Les paiements et reversements sont traités selon les étapes vérifiées de votre expédition.",
    "pay.now": "Payer maintenant",
    "pay.paid": "Paiement confirmé",
    "pay.protectedNote": "Paiement protégé : les fonds sont reversés au partenaire par jalons (30% réception, 60% départ, 10% livraison).",
    "pay.awaiting": "En attente du paiement client",
    "pay.checking": "Vérification du paiement…",
    "pay.successTitle": "Paiement confirmé !",
    "pay.successDesc": "Votre paiement est sécurisé sur la plateforme. Le partenaire a été notifié et votre expédition va partir.",
    "pay.errorTitle": "Paiement non confirmé",
    "pay.errorDesc": "Le paiement n'a pas abouti. Vous pouvez réessayer depuis la page de votre expédition.",
    "pay.timeoutDesc": "La vérification prend plus de temps que prévu. Revenez dans quelques minutes depuis votre tableau de bord.",
    "pay.cancelTitle": "Paiement annulé",
    "pay.cancelDesc": "Aucun montant n'a été débité. Vous pouvez relancer le paiement à tout moment.",
    "pay.backDash": "Retour au tableau de bord",
    "pay.pendingBadge": "Paiement en attente",
    "pay.cancelledBadge": "Paiement annulé",
    "pay.refundedBadge": "Paiement remboursé",
    "pay.cardBtn": "Payer par carte — lien sécurisé",
    "pay.manualNote": "Colis2Go vous enverra le lien de paiement par carte ou les instructions Orange Money (Guinée / Côte d'Ivoire).",
    "partner.dash.earnings": "Revenus",
    "earn.total": "Total des reversements (paiement protégé)",
    "earn.released": "Reversé",
    "earn.pending": "En attente de jalon",
    "earn.none": "Aucun reversement pour le moment. Vos revenus apparaissent après paiement du client.",
    "mobile.search": "Rechercher",
    "mobile.shipments": "Expéditions",
    "mobile.quotes": "Devis",
    "mobile.receive": "Réception",
    "mobile.earnings": "Revenus",
    "mobile.profile": "Profil",
    "scan.open": "Scanner",
    "scan.title": "Scanner le QR code",
    "scan.hint": "Placez le QR code de l'expédition dans le cadre.",
    "scan.cameraError": "Caméra indisponible. Autorisez l'accès à la caméra ou sélectionnez la référence manuellement.",
    "auth.phone": "Téléphone (avec indicatif)",
    "auth.country": "Pays de résidence",
    "auth.city": "Ville",
    "auth.company": "Nom de la société",
    "auth.depotCountry": "Pays du dépôt",
    "auth.depotCity": "Ville du dépôt",
    "auth.address": "Adresse de réception (dépôt)",
    "auth.addressHint": "Facultatif à l'inscription — complétable dans votre profil. Révélée aux clients uniquement après réservation.",
    "route.tiers": "Paliers de prix",
    "route.addTier": "Ajouter un palier",
    "route.tiersRequired": "Ajoutez au moins un palier de prix",
    "route.from": "De",
    "route.to": "à (0 = ∞)",
    "route.price": "Prix",
    "route.minBillable": "Minimum facturable (kg)",
    "route.volDivisor": "Diviseur volumétrique",
    "route.specialSurcharge": "Supplément marchandise spéciale (€)",
    "route.deliverySurcharge": "Supplément livraison (€)",
    "route.destFees": "Frais de destination (€)",
    "route.minCbm": "Minimum CBM",
    "route.docFees": "Frais de documentation (€)",
    "route.customsFees": "Dédouanement (€)",
    "route.palletPrice": "Prix par palette (€)",
    "route.cartonPrice": "Prix par carton (€)",
    "profile.phone": "Téléphone",
    "profile.logo": "Logo (URL)",
    "profile.specialConditions": "Conditions particulières",
    "profile.customsIncluded": "Dédouanement inclus",
    "profile.deliveryIncluded": "Livraison finale incluse",
    "partner.conditions": "Conditions particulières",
    "trust.title": "Protection Plateforme",
    "trust.desc": "Partenaires vérifiés, prix enregistrés, photos, pesée réelle, suivi et preuves à chaque étape de votre expédition.",
    "mobile.home": "Accueil",
    "mobile.packages": "Colis",
    "mobile.more": "Plus",
    "mobile.suppliers": "Fournisseurs",
    "mobile.favorites": "Favoris",
    "mobile.support": "Support",
    // --- Landing ---
    "landing.card1.title": "J'ai déjà ma marchandise",
    "landing.card1.desc": "Votre marchandise est au UK, en Europe, aux USA ou en Chine ? Envoyez-la à votre adresse Colis2Go, nous l'expédions vers l'Afrique.",
    "landing.card1.cta": "Expédier ma marchandise",
    "landing.card1.estimate": "Estimer par articles",
    "landing.card2.title": "Je veux acheter en ligne",
    "landing.card2.desc": "Obtenez une adresse locale, faites vos achats en ligne et expédiez-les ensuite vers votre destination.",
    "landing.card2.cta": "Acheter & expédier",
    "landing.step1.title": "Comparez",
    "landing.step1.desc": "Origine → destination, aérien ou maritime.",
    "landing.step2.title": "Réservez",
    "landing.step2.desc": "Code unique + QR + adresse du dépôt.",
    "landing.step3.title": "Consolidez",
    "landing.step3.desc": "Plusieurs fournisseurs, un seul envoi.",
    "landing.step4.title": "Suivez",
    "landing.step4.desc": "Photos, poids, CBM et tracking jusqu'à l'arrivée.",
    "landing.airDesc": "Prix au kg, poids taxable, départs fréquents.",
    "landing.seaDesc": "Prix au CBM, groupage container, économique.",
    "landing.consoTitle": "Consolidation",
    "landing.consoDesc": "Réception multi-fournisseurs au même dépôt.",
    // --- Achats en ligne ---
    "ss.badge": "Achats en ligne",
    "ss.title": "Je veux acheter en ligne",
    "ss.subtitle": "Dites-nous où vous achetez : nous vous donnons la bonne adresse Colis2Go. Nous réceptionnons vos colis, les regroupons et les expédions vers votre destination.",
    "ss.step1": "1. Où souhaitez-vous acheter ?",
    "ss.step2": "2. Votre adresse Colis2Go",
    "ss.loginPrompt": "Connectez-vous pour obtenir votre adresse personnelle et votre code client.",
    "ss.loginBtn": "Se connecter",
    "ss.customersOnly": "Réservé aux comptes clients.",
    "ss.clientCode": "Votre code client :",
    "ss.copyAddress": "Copier mon adresse",
    "ss.copyInstructions": "Copier les instructions",
    "ss.step3": "3. Mon lot d'achats",
    "ss.step4Customer": "4. Faites vos achats",
    "ss.step3Guest": "3. Faites vos achats",
    "ss.declared": "J'ai passé ma commande",
    "ss.visit": "Visiter la boutique",
    "ss.noShops": "Aucune boutique dans cette catégorie.",
    "ss.unlistedQ": "Vous ne trouvez pas votre boutique ?",
    "ss.unlistedBtn": "UTILISER UNE AUTRE BOUTIQUE",
    "ss.disclaimer": "Colis2Go n'est affilié à aucune de ces marques. Les boutons ouvrent leurs sites officiels.",
    "ss.followTitle": "Suivez vos achats dans « Mes achats »",
    "ss.followDesc": "Déclarez chaque commande pour que l'entrepôt l'attende, puis consolidez et expédiez.",
    "ss.myPurchases": "Mes achats",
    "ss.catAll": "Toutes",
    // --- Marchandise existante ---
    "goods.badge": "J'ai déjà ma marchandise",
    "goods.title": "Expédiez votre marchandise vers l'Afrique",
    "goods.subtitle": "Où qu'elle se trouve — UK, Europe, USA, Chine… — envoyez-la à votre adresse Colis2Go : nous la réceptionnons, la vérifions et l'expédions vers Conakry ou Abidjan.",
    "goods.step1": "1. Où se trouve actuellement votre marchandise ?",
    "goods.step2": "2. Votre Hub Colis2Go",
    "goods.multiHub": "Plusieurs Hubs sont disponibles — choisissez celui qui vous convient.",
    "goods.noHub": "Aucun Hub actif dans ce pays pour le moment.",
    "goods.addrLater": "L'adresse complète du Hub vous sera communiquée dès la création de votre expédition.",
    "goods.step3": "3. Destination finale",
    "goods.destCountry": "Pays de destination",
    "goods.destCity": "Ville",
    "goods.step4": "4. Votre marchandise",
    "goods.searchPh": "Rechercher : TV, fût, carton, valise…",
    "goods.notInCatalog": "Nous n'avons pas encore cet article dans notre catalogue.",
    "goods.addCustom": "Ajouter mon article",
    "goods.yourShipment": "Votre envoi",
    "goods.emptyCart": "Aucun article. Recherchez ci-dessus ou indiquez un poids estimé.",
    "goods.weight": "Poids estimé (kg, facultatif)",
    "goods.estimateBtn": "Estimer le prix",
    "goods.estimatePrefix": "Prix estimatif :",
    "goods.estimateNote": "Cette estimation est basée sur les informations déclarées et pourra être ajustée après vérification de la marchandise au Hub.",
    "goods.quoteOnly": "Sur devis — le prix final sera communiqué après réception et vérification au Hub. Aucun tarif n'est inventé automatiquement.",
    "goods.onQuoteShort": "article(s) sur devis",
    "goods.customTitle": "Ajouter mon article",
    "goods.customDesc2": "Article non répertorié. Le montant sera vérifié par Colis2Go après réception.",
    "goods.customName": "Nom de l'article",
    "goods.customQty": "Quantité",
    "goods.customWeight": "Poids estimé (kg)",
    "goods.customDescLabel": "Description",
    "goods.customSubmit": "Ajouter à mon envoi",
    "common.onQuote": "Sur devis",

    "goods.sendTo": "Envoi au",
    "goods.ready": "Prêt ?",
    "goods.readyDesc": "Référence unique + adresse complète du Hub dès la création. Colis2Go organise ensuite le transport jusqu'à",
    "goods.submit": "Créer mon expédition",
    "goods.loginToContinue": "Se connecter pour continuer",
    "goods.creating": "Création…",
    // --- Lot d'achats ---
    "lot.title": "Mes achats en cours",
    "lot.prefQ": "Comment souhaitez-vous expédier vos achats ? (simple préférence — modifiable tant que la consolidation n'a pas commencé)",
    "lot.prefGroup": "Regrouper mes achats",
    "lot.prefSeparate": "Expédier séparément",
    "lot.prefLater": "Je déciderai plus tard",
    "lot.stOpen": "Ouvert",
    "lot.stFinishing": "En attente de colis",
    "lot.stReady": "Colis au complet — à vous de choisir",
    "lot.stToConsolidate": "En préparation chez Colis2Go",
    "lot.stToPrepare": "En préparation (colis séparés)",
    "lot.stConsolidated": "Consolidation terminée",
    "lot.stPrepared": "Colis préparés",
    "lot.stClosed": "Clôturé",
    "lot.counter": "{t} achat(s) · {r} reçu(s) sur {t}",
    "lot.empty": "Aucun achat dans ce lot pour l'instant.",
    "lot.itemReceived": "Reçu",
    "lot.itemInTransit": "En route",
    "lot.itemExpected": "Attendu",
    "lot.waiting": "{r} colis reçu(s) sur {t}. Nous attendons encore vos colis :",
    "lot.readyQ": "Tous vos colis sont arrivés — comment souhaitez-vous les expédier ?",
    "lot.toConsolidateInfo": "Consolidation en cours à l'entrepôt Colis2Go — vous serez notifié dès qu'elle est terminée.",
    "lot.toPrepareInfo": "Vos colis seront préparés et expédiés séparément par l'entrepôt.",
    "lot.doneNext": "Lancez l'expédition depuis « Mes achats ». Tout nouvel achat créera un nouveau lot.",
    "lot.addPurchase": "Ajouter un autre achat",
    "lot.finish": "J'ai terminé mes achats",
    "lot.reopen": "Rouvrir le lot",
    "lot.attach": "Ajouter au lot",
    "lot.outside": "(hors lot)",
    "lot.created": "Lot d'achats créé",
    "lot.attached": "Achat ajouté au lot",
    // --- WhatsApp ---
    "wa.cta": "DISCUTER AVEC COLIS2GO SUR WHATSAPP",
    "wa.msgRef": "Bonjour Colis2Go, j'ai une question concernant mon expédition {ref}.",
    "wa.msg": "Bonjour Colis2Go, j'ai une question.",
    "auth.backHome": "Retour à l'accueil",
    "auth.forgot": "Mot de passe oublié ?",
    "auth.pwdMin": "8 caractères minimum.",
    "auth.connected": "Connecté",
    "auth.accountCreated": "Compte créé — vérifiez votre adresse email",
    "otp.enter6": "Entrez le code à 6 chiffres",
    "otp.invalid": "Code invalide ou expiré",
    "otp.resent": "Nouveau code envoyé",
    "otp.wait": "Patientez avant de renvoyer",
    "otp.verifyTitle": "Vérifiez votre adresse email",
    "otp.sub1": "Nous avons envoyé un code à 6 chiffres à",
    "otp.sub2": ". Il expire dans 10 minutes.",
    "otp.verifyBtn": "Vérifier mon email",
    "otp.resend": "Renvoyer le code",
    "otp.editEmail": "Modifier mon adresse email",
    "otp.newEmail": "Nouvelle adresse email",
    "otp.updateResend": "Mettre à jour et renvoyer",
    "otp.already": "Déjà vérifié ?",
    "otp.verified": "Adresse email vérifiée — votre compte est activé",
    "otp.sentTo": "Code envoyé à",
    "fp.title": "Récupérer mon compte",
    "fp.sub1": "Saisissez l'email de votre compte — nous vous enverrons un code de sécurité.",
    "fp.enterEmail": "Saisissez votre email",
    "fp.newPwd": "Nouveau mot de passe",
    "fp.confirmPwd": "Confirmer le nouveau mot de passe",
    "fp.pwdMin8": "Au moins 8 caractères",
    "fp.pwdMismatch": "Les mots de passe ne correspondent pas",
    "est.title": "Qu'envoyez-vous ?",
    "est.subtitle": "Indiquez ce que vous souhaitez envoyer pour obtenir une estimation.",
    "est.originPh": "Pays d'origine",
    "est.destPh": "Pays de destination",
    "est.allModes": "Tous les modes",
    "est.searchPh": "Rechercher un article : TV, fût, carton 28, Ghana Must Go…",
    "est.cta": "OBTENIR UNE ESTIMATION",
    "est.verified": "Vérifié",
    "est.battery": "Batterie",
    "est.customDesc": "Article non répertorié : il sera confirmé par devis après vérification.",
    "dash.home": "Accueil",
    "dash.purchases": "Mes achats en ligne",
    "dash.purchasesSub": "Ce que vous avez commandé sur internet.",
    "dash.packagesSub": "Vos colis reçus chez Colis2Go et leur évolution jusqu'à la livraison.",
    "dash.shipmentsSub": "Suivez vos marchandises prêtes ou expédiées vers leur destination.",
    "st.inTransit": "En transit",
    "prep.title": "Préparer mon envoi",
    "prep.pick": "Sélectionnez les colis que vous souhaitez traiter ensemble.",
    "prep.received": "Reçu",
    "prep.expected": "Attendu",
    "prep.none": "Aucun colis reçu disponible pour le moment.",
    "prep.qOne": "Que souhaitez-vous faire ?",
    "prep.send": "Envoyer ce colis",
    "prep.qMany": "Comment souhaitez-vous préparer ces colis ?",
    "prep.group": "Regrouper mes colis",
    "prep.separate": "Garder mes colis séparés",
    "prep.wait": "Attendre encore",
    "prep.sent": "C'est noté — Colis2Go prépare votre envoi.",
    "prep.waiting": "C'est noté — nous attendons vos colis manquants avant de continuer.",
    "st.available": "Disponible au retrait",
    "dash.packages": "Mes colis",
    "dash.addresses": "Mes adresses Colis2Go",
    "dash.suppliers": "Fournisseurs",
    "dash.support": "Support",
    "st.created": "Créée",
    "st.receiving": "Réception",
    "st.consolidated": "Consolidée",
    "st.paid_pending": "Prix accepté — paiement en attente",
    "st.paid": "Prêt au départ",
    "st.shipped": "Expédiée",
    "st.arrived": "Arrivée",
    "st.delivered": "Retiré / Livré",
    "ps.announced": "Achat déclaré / colis attendu",
    "ps.in_transit": "En route",
    "ps.partial": "Réception partielle",
    "ps.received": "Reçu",
    "ps.unannounced": "Colis non annoncé",
    "ps2.declared": "Achat déclaré",
    "ps2.expected": "Colis attendu",
    "ps2.received": "Colis reçu",
    "fp.title": "Votre facture est disponible",
    "fp.air": "Aérien / Express",
    "fp.sea": "Maritime",
    "fp.accept": "Accepter le prix",
    "fp.question": "J'ai une question",
    "fp.accepted": "Prix accepté — votre dossier passe en paiement.",
    "ps.consolidated": "Consolidé / expédié",
    "ps.rejected": "Rejeté",
    "ssx.myTitle": "Mes achats en ligne",
    "ssx.consolidateSel": "Consolider ces colis",
    "ssx.markTransit": "Marquer en route",
    "ssx.notMine": "Ce n'est pas mon colis",
    "ssx.viewShipment": "Voir l'expédition",
    "ssx.details": "Voir les détails",
    "ssx.prepTitle": "Préparer mon expédition",
    "ssx.addrTitle": "Mes adresses Achats en ligne",
    "ssx.copied": "Adresse copiée",
    "ssx.selHint": "Cochez les achats reçus à regrouper, ou attendez d'autres colis — rien ne vous oblige à expédier tout de suite.",
    "ssd.title": "Déclarer mon achat",
    "ssd.shop": "Boutique",
    "ssd.order": "N° de commande",
    "ssd.tracking": "Tracking (facultatif)",
    "ssd.expected": "Colis attendus",
    "ssd.value": "Valeur (facultatif)",
    "ssd.dest": "Destination finale",
    "ssd.chooseDest": "Choisir la destination",
    "ssd.desc": "Description de la marchandise",
    "ssd.notes": "Notes",
    "ssd.submit": "Déclarer",
    "unl.title": "Utiliser une autre boutique",
    "unl.desc": "Indiquez simplement le nom — pas besoin de connaître le site. Nous le retrouvons pour vous.",
    "unl.search": "Rechercher",
    "unl.searching": "Recherche…",
    "unl.useThis": "UTILISER CETTE BOUTIQUE",
    "unl.noUrl": "CONTINUER SANS URL",
    "unl.inCatalog": "déjà dans notre catalogue",
    "unl.found": "site officiel trouvé",
    "goods.routeMsg": "Pour cette marchandise, envoyez votre colis à votre adresse Colis2Go {label}.",
    "goods.chainCheck": "Réception & vérification",
    "goods.chainShip": "Expédition Afrique",
    "ss.routeMsg": "Vous achetez en {c} ? Utilisez votre adresse Colis2Go {label}.",
    "sd.totalEst": "Total estimé",
    "sd.indicative": "Prix estimatif — prix final après réception et vérification de la marchandise.",
    "sd.adjusted": "Prix ajusté après vérification",
    "sd.confirmed": "Confirmé",
    "sd.awaitingDepot": "En attente de réception au dépôt.",
    "sd.consolidateBtn": "Consolider mes colis puis expédier",
    "sd.shipAsIs": "Expédier tel quel",
    "sd.collectedBy": "Collecté par",
    "sd.declare": "Déclarer un achat",
    "sd.report": "Signaler un problème",
    "cat.Toutes": "Toutes",
    "cat.Mode": "Mode",
    "cat.Électronique": "Électronique",
    "cat.Beauté": "Beauté",
    "cat.Maison": "Maison",
    "cat.Sport": "Sport",
    "cat.Marketplace": "Marketplace",
    "cat.Autres": "Autres",
    "ctry.Royaume-Uni": "Royaume-Uni",
    "ctry.France": "France",
    "ctry.Allemagne": "Allemagne",
    "ctry.Espagne": "Espagne",
    "ctry.Belgique": "Belgique",
    "ctry.Italie": "Italie",
    "ctry.Pays-Bas": "Pays-Bas",
    "ctry.USA": "USA",
    "ctry.Chine": "Chine",
    "ctry.Turquie": "Turquie",
    "ctry.Émirats (Dubaï)": "Émirats (Dubaï)",
    "ctry.Autre pays": "Autre pays",
    "geo.searchCountry": "Rechercher votre pays",
    "goods.tracking": "N° de suivi (optionnel)",
    "holder.q": "Chez qui se trouve actuellement la marchandise ?",
    "holder.self": "Chez moi",
    "holder.supplier": "Chez mon fournisseur / vendeur",
    "holder.relative": "Chez un proche / ami / famille",
    "goods.instrSupplier": "Instructions pour mon fournisseur",
    "goods.instrRelative": "Instructions pour la personne qui m'envoie le colis",
    "goods.instrSelf": "Votre adresse Colis2Go",
    "goods.instrSend": "Envoyez la marchandise à :",
    "goods.instrRef": "Référence à indiquer :",
    "goods.instrDest": "Destination finale :",
    "goods.instrMode": "Mode :",
    "goods.instrTrack": "Merci de fournir le numéro de suivi de l'envoi.",
    "goods.copy": "Copier",
    "goods.share": "Partager",
    "goods.viewShipment": "Voir mon expédition",
    "goods.copied": "Instructions copiées",
    "goods.holderFirst": "Indiquez d'abord qui possède votre marchandise.",
    "proh.link": "marchandises interdites / soumises à conditions",
    "proh.ack": "Je confirme avoir lu la liste des",
    "proh.title": "Marchandises interdites / soumises à conditions",
    "nav.how": "Comment ça marche ?",
    "na.title": "Votre prochaine action",
    "na.go": "Voir",
    "na.price": "Votre prix final est disponible ({ref}). Voir et accepter le prix.",
    "na.payment": "Votre paiement est en attente ({ref}).",
    "na.choose": "Tous vos colis sont arrivés ({ref}). Choisissez si vous souhaitez les regrouper.",
    "na.waiting": "Nous attendons votre colis {shop}. Aucune action requise.",
    "na.waitingGoods": "Nous attendons votre marchandise ({ref}). Aucune action requise.",
    "na.transit": "Votre colis est en transit ({ref}). Aucune action nécessaire.",
    "na.arrived": "Votre colis est arrivé à {city} ({ref}). Disponible au retrait.",
    "na.start": "Commencez : achetez en ligne ou envoyez une marchandise que vous possédez déjà.",
    "na.receivedInfo": "{n} colis reçu(s) chez Colis2Go. Votre facture arrive très prochainement.",
    "dash.goods": "J'ai déjà ma marchandise",
    "dash.goodsSub": "Les marchandises que vous, un proche ou un fournisseur possédez déjà.",
    "gd.announced": "Marchandise annoncée — instructions disponibles",
    "gd.receiving": "En route / réception partielle",
    "gd.received": "Reçue chez Colis2Go",
    "gd.announce": "Annoncer une marchandise",
    "gd.instructions": "Voir les instructions",
    "gd.none": "Aucune marchandise annoncée.",
    "gd.history": "Historique — marchandises reçues",
    "src.online": "Achat en ligne",
    "src.supplier": "Fournisseur",
    "src.relative": "Proche / famille",
    "src.self": "Moi-même",
    "src.goods": "Marchandise",
    "q.purchase": "Question sur cet achat",
    "q.goods": "Question sur cette marchandise",
    "q.parcel": "Question sur ce colis",
    "q.ship": "Question sur cet envoi",
    "st.ready": "Prêt au départ",
    "ship.track": "Voir le suivi",
    "prep.pipeline": "Envois en préparation",
    "prep.awaitPay": "Facture acceptée — paiement en attente",
    "pk.tracking": "Suivi de vos colis",
    "inv.history": "Historique des paiements",
    "inv.number": "Facture",
    "inv.ref": "Référence",
    "inv.amount": "Montant",
    "inv.date": "Date",
    "inv.status": "Statut",
    "inv.pending": "En attente",
    "inv.toPay": "À payer",
    "inv.initial": "Facture initiale",
    "inv.paid": "Payée",
    "inv.refunded": "Remboursé",
    "inv.cancelled": "Annulé",
    "cx.cancel": "Annuler",
    "cx.title": "Annulation",
    "cx.fee": "Frais de traitement",
    "cx.confirm": "Confirmer l'annulation",
    "cx.keep": "Garder mon dossier",
    "cx.done": "Annulation confirmée",
    "vf.banner": "Votre adresse email n'est pas encore vérifiée — l'email est notre canal principal de notification.",
    "vf.action": "Vérifier mon email",
    "pu.code": "Code de retrait",
    "pu.codeHint": "à présenter au retrait (aussi envoyé par email)",
    "pu.person": "Personne autorisée",
    "pu.nobody": "Personne d'autre n'est autorisée à retirer ce colis.",
    "pu.setPerson": "Autoriser quelqu'un d'autre",
    "pu.edit": "Modifier",
    "pu.hint": "Cette personne pourra retirer votre colis à votre place. Le code de retrait reçu par email restera exigé.",
    "pu.name": "Nom complet",
    "pu.phone": "Téléphone",
    "pu.idnum": "N° pièce d'identité (optionnel)",
    "pu.save": "Enregistrer",
    "pu.saved": "Personne autorisée enregistrée — confirmation envoyée par email",
    "pu.receipt": "Reçu de remise (PDF)",
    "ci.title": "Destination hors Abidjan",
    "ci.body": "Votre colis arrivera d'abord à Abidjan. Des frais supplémentaires peuvent s'appliquer pour l'acheminement jusqu'à votre ville finale. Colis2Go vous communiquera le montant si nécessaire.",
    "dc.warnTitle": "Destination hors",
    "dc.warnBody1": "Votre colis arrivera d'abord à",
    "dc.warnBody2": "Des frais supplémentaires peuvent s'appliquer pour l'acheminement jusqu'à votre ville finale. Colis2Go vous communiquera le montant si nécessaire.",
    "dc.arrival": "Ville de destination *",
    "dc.unavailable": "Cette ville n'est pas disponible actuellement.",
    "est.modeIncompatible": "Cet article n'est pas disponible avec ce mode de transport. Veuillez choisir un autre article.",
    "md.mode": "Mode de transport *",
    "md.noDep": "Aucun départ planifié pour le moment. Vous pouvez continuer votre expédition. Le départ sera attribué ultérieurement par Colis2Go.",
    "md.nextDep": "Prochain départ prévu",
    "md.indicative": "Départ indicatif. Le voyage définitif sera confirmé selon la réception de votre marchandise au Hub et la clôture du départ.",
    "md.assignAfter": "Votre colis sera affecté à un départ après sa réception au Hub Colis2Go.",
    "pk.enroute": "En route",
    "pk.departure": "Départ prévu :",
    "pk.request": "J'ai une demande particulière",
    "pk.dep": "Départ :",
    "ssd.departure": "Départ souhaité (facultatif)",
    "ssd.chooseDep": "— Sélectionner une date de départ —",
    "ssd.noDep": "Pas encore de départ planifié — Colis2Go vous informera",
    "ssd.cutoff": "clôture",
    "sst.edit": "Modifier",
    "sst.editTitle": "Modifier ma déclaration",
    "sst.editDesc": "Modifiable tant que le colis n'est pas reçu chez Colis2Go.",
    "sst.editOk": "Déclaration mise à jour",
    "sst.editSave": "Enregistrer",
    "na.receivedInfo": "{n} colis reçu(s) chez Colis2Go. Votre facture arrive très prochainement.",
    "ai.q": "Que souhaitez-vous acheter ?",
    "ai.ph": "Ex : des baskets Nike, une robe de soirée, un téléphone…",
    "ai.btn": "Suggérer des boutiques",
    "ai.busy": "Je réfléchis…",
    "ai.understood": "Recherche comprise",
    "dashx.hello": "Bonjour {name}",
    "dashx.whatDo": "Que souhaitez-vous faire ?",
    "dashx.buyOnline": "Je veux acheter en ligne",
    "dashx.buyOnlineD": "Obtenez votre estimation et votre adresse Colis2Go pour effectuer un nouvel achat.",
    "dashx.haveGoods": "J'ai déjà ma marchandise",
    "dashx.haveGoodsD": "Créez une nouvelle expédition pour une marchandise que vous, un proche ou votre fournisseur possédez déjà.",
    "dashx.myPackages": "Mes colis chez Colis2Go",
    "dashx.myShipments": "Mes envois vers l'Afrique",
    "dashx.how": "Comment ça marche ?",
    "dashx.help": "Besoin d'aide ? WhatsApp",
    "hiw.title": "Comment ça marche ?",
    "hiw.v1": "Acheter en ligne avec Colis2Go",
    "hiw.v1d": "Recevez votre adresse Colis2Go, achetez dans vos boutiques préférées et déclarez vos achats.",
    "hiw.v2": "J'ai déjà ma marchandise",
    "hiw.v2d": "Votre fournisseur, un proche ou vous-même envoyez la marchandise à votre Hub Colis2Go.",
    "hiw.v3": "Après réception : consolidation, prix, paiement, expédition",
    "hiw.v3d": "Nous recevons vos colis, les regroupons si vous le souhaitez, puis vous payez et suivez l'expédition.",
    "hiw.soon": "Vidéo bientôt disponible",
    "hiw.faqTitle": "Questions fréquentes",
    "hiw.q1": "Comment obtenir mon adresse Colis2Go ?",
    "hiw.a1": "Cliquez sur « Je veux acheter en ligne », choisissez le pays où vous achetez : nous vous attribuons automatiquement l'adresse France ou UK avec votre code C2G.",
    "hiw.q2": "Puis-je regrouper plusieurs achats ?",
    "hiw.a2": "Oui. Déclarez chaque achat dans votre lot, puis choisissez « Regrouper mes achats ». Nous consolidons vos colis à l'entrepôt pour réduire le coût.",
    "hiw.q3": "Quand est-ce que je paie ?",
    "hiw.a3": "Après réception (et consolidation éventuelle), nous vous envoyons le prix final. Vous l'acceptez, puis vous payez par lien Stripe ou Orange Money.",
    "hiw.ctaShop": "Je veux acheter en ligne",
    "hiw.ctaGoods": "J'ai déjà ma marchandise",
    "geo.noResult": "Aucun pays trouvé",
    "customs.title": "Information douanière",
    "customs.p1": "Avant d'envoyer votre marchandise à votre adresse Colis2Go UK, veuillez vérifier avec votre vendeur ou fournisseur si des frais de douane, taxes d'importation ou frais de dédouanement supplémentaires peuvent s'appliquer à l'arrivée.",
    "customs.p2": "Certains vendeurs ou plateformes peuvent déjà inclure ces frais dans leurs conditions de livraison, tandis que d'autres peuvent les facturer séparément.",
    "customs.p3": "Colis2Go ne calcule pas et ne garantit pas ces frais. Les éventuels frais d'importation avant réception chez Colis2Go restent à la charge du client.",
    "customs.ack": "J'ai compris.",
    "customs.continue": "Continuer",
    "qa.declare": "Déclarer un achat",
    "qa.myShipments": "Mes expéditions",
    "qa.track": "Suivre une expédition",
    "qa.noDeclared": "Aucun achat déclaré. Utilisez « Déclarer un achat » pour annoncer vos marchandises.",
    "qa.receivedAtDepot": "Colis reçus au dépôt",
    "qa.noneReceived": "Aucun colis reçu pour le moment.",
    "qa.delay": "Délai :",
    "qa.supportHint": "Pour signaler un problème sur une expédition (colis manquant, poids contesté, dommage, retard…), ouvrez la fiche de l'expédition concernée puis cliquez sur « Signaler un problème ».",
    "qa.resolution": "Résolution :",
    "qa.fromPrice": "dès",
    "dp.title": "Déclarer un achat / colis attendu",
    "dp.desc": "Annoncez à l'entrepôt les marchandises qui vont arriver.",
    "dp.shipment": "Expédition concernée",
    "dp.choose": "Choisir une expédition",
    "dp.weightEst": "Poids estimé (kg)",
    "dp.value": "Valeur déclarée (€)",
    "sst.completeTitle": "Compléter les informations",
    "sst.completeDesc": "Confirmez ce colis en précisant la boutique et la commande.",
    "sst.quoteNote": "Sur devis — le prix final sera communiqué après réception et vérification.",
    "sst.tel": "Tél :",
    "hub.addr": "Adresse",
    "hub.city": "Ville",
    "hub.postal": "Code postal",
    "hub.country": "Pays",
    "hub.phone": "Téléphone",
    "hub.hours": "Horaires",
    "sst.noAddress": "Aucune adresse activée. Choisissez un pays dans « Acheter & expédier ».",
    "ss.copiedAddr": "Adresse copiée — collez-la sur la boutique en ligne",
    "ss.copiedInstr": "Instructions copiées",
    "unl.noneFound": "Aucun site fiable identifié — vous pouvez continuer, notre équipe complétera l'adresse du site.",
    "ssd.recvDesc": "Adresse de réception : {c}. L'entrepôt verra ce colis dans « Colis attendus ».",
    "fp.sub2a": "Entrez le code reçu à",
    "fp.sub2b": ". Il expire dans 10 minutes.",
    "fp.smsLater": "La récupération par SMS sera proposée lorsque votre téléphone sera vérifié et le service SMS activé.",
    "fp.backLogin": "Retour à la connexion",
    "sup.title": "Nouveau fournisseur",
    "sup.desc": "Enregistrez vos fournisseurs pour les réutiliser dans vos déclarations.",
    "sup.phone": "Téléphone",
    "sup.none": "Aucun fournisseur enregistré.",
    "prof.country": "Pays de résidence",
    "prof.lang": "Langue préférée",
    "prof.currency": "Devise préférée",
    "prof.addrLabel": "Libellé (Maison, Bureau…)",
    "sd.copyInstr2": "Instructions copiées — collez-les sur WhatsApp, Alibaba ou par email",
    "sd.addSuppliers": "Ajoutez vos fournisseurs et transmettez-leur l'adresse + la référence.",
    "sd.hubWait": "En attente de réception de vos marchandises au Hub. Transmettez l'adresse et la référence à vos fournisseurs.",
    "sd.hubArrived": "Vos colis sont arrivés au Hub. Que souhaitez-vous faire ? La consolidation n'est jamais obligatoire.",
    "sd.declDesc": "L'entrepôt verra ce colis dans « Colis attendus ».",
    "sd.reviewDesc": "Notez chaque critère de 1 à 5 étoiles.",
    "sd.noMessages": "Aucun message. Les échanges importants restent attachés au dossier.",
    "sd.disputeDesc": "Un dossier de litige sera visible par l'équipe Colis2Go.",
    "sd.issueType": "Type de problème",
    "ssd.destPh": "Guinée, Côte d'Ivoire…",
    "est.cartTitle": "Votre envoi",
    "est.cartEmpty": "Aucun article. Recherchez ci-dessus ou ajoutez un poids en kg.",
    "est.smallParcel": "Petit colis (kg, facultatif)",
    "est.calc": "Calcul…",
    "est.batteryWarn": "· Batterie / validation transport requise",
    "est.viaHub": "Collecte via Hub Colis2Go",
    "est.days": "jours",
    "est.destFees": "Frais destination",
    "est.approval": "Approbation requise",
    "est.book": "Réserver",
    "est.nameReq": "Nom de l'article requis",
    "est.addedUnlisted": "Article ajouté — statut « non répertorié », confirmé par devis",
    "est.chooseOD": "Choisissez l'origine et la destination",
    "est.addOne": "Ajoutez au moins un article ou un poids",
    "est.noOffer": "Aucune offre sur ce corridor — essayez un autre mode ou demandez un devis",
    "est.custOnly": "Connectez-vous en tant que client",
    "est.created": "Expédition {ref} créée",
    "est.bookErr": "Erreur lors de la réservation",
    "est.quoteSent": "Demande de devis envoyée",
    "sst.myParcel": "C'est mon colis",
    "sst.confirmMine": "Confirmer — c'est mon colis",
    "sst.confirmed": "Colis confirmé",
    "sst.rejected": "Colis rejeté",
    "sst.err": "Erreur",
    "sst.noDeclared": "Aucun achat déclaré. Passez par « Acheter & expédier » puis « J'ai passé ma commande ».",
    "sst.addCountry": "Ajouter un pays",
    "sst.myAddr": "Mon adresse",
    "sst.copy": "Copier",
    "sst.hours": "Horaires",
    "sst.destReq": "Destination requise",
    "sst.consoOk": "Consolidation demandée — expédition {ref} créée",
    "sst.cityOpt": "Ville (facultatif)",
    "sst.selCount": "achat(s) sélectionné(s)",
    "qa.resolved": "Résolu",
    "qs.accepted": "Accepté",
    "qs.refused": "Refusé",
    "ps.to_wh": "En route vers l'entrepôt",
    "ctry.Guinée": "Guinée",
    "ctry.Côte d'Ivoire": "Côte d'Ivoire",

  },
  en: {
    "app.name": "Colis2Go",
    "app.tagline": "Air & sea cargo consolidation to Africa",
    "nav.search": "Search",
    "nav.howItWorks": "How it works",
    "nav.partners": "Partners",
    "nav.login": "Log in",
    "nav.register": "Sign up",
    "nav.dashboard": "Dashboard",
    "nav.logout": "Log out",
    "nav.becomePartner": "Become a partner",
    "hero.title": "Shop anywhere. Ship to Africa.",
    "hero.subtitle": "Send your goods to your Colis2Go hub, compare prices, book and track every shipment by air or sea.",
    "search.originTitle": "Where are your goods right now?",
    "search.destTitle": "Where would you like to send them?",
    "search.country": "Country",
    "search.city": "City",
    "search.mode": "Transport mode",
    "search.air": "Air / Express",
    "search.sea": "Sea freight",
    "search.all": "All",
    "search.cta": "Find a partner",
    "search.selectCountry": "Select a country",
    "search.selectCity": "All cities",
    "results.title": "Available partners",
    "results.none": "No partners on this route yet — it isn't active at the moment.",
    "results.verified": "Verified partner",
    "results.shipments": "shipments completed",
    "results.departures": "Departures",
    "results.delay": "Typical transit time",
    "results.days": "days",
    "results.viewProfile": "View profile",
    "results.book": "Book now",
    "results.from": "from",
    "partner.routes": "Routes served",
    "partner.reviews": "Verified reviews",
    "partner.about": "About",
    "partner.acceptedGoods": "Accepted goods",
    "partner.forbiddenGoods": "Prohibited items",
    "partner.depotHours": "Warehouse opening hours",
    "partner.customs": "Customs clearance included",
    "partner.delivery": "Final delivery included",
    "partner.yes": "Yes",
    "partner.no": "No",
    "partner.requestQuote": "Request a quote",
    "partner.book": "Book this route",
    "auth.loginTitle": "Log in",
    "auth.registerTitle": "Create your account",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.name": "Full name",
    "auth.role": "I am a",
    "auth.customer": "Customer",
    "auth.partner": "Consolidation partner",
    "auth.loginBtn": "Log in",
    "auth.registerBtn": "Sign up",
    "auth.google": "Continue with Google",
    "auth.facebook": "Continue with Facebook",
    "fb.linkPrompt": "A Colis2Go account already exists with this email. Sign in with your usual method to securely link your Facebook account.",
    "fb.linked": "Facebook account linked — you can now sign in with Facebook.",
    "fb.noEmail": "Your Facebook account does not provide an email address. Create an account with your email, then sign in with Facebook again.",
    "fb.cancelled": "Facebook sign-in cancelled.",
    "fb.error": "Facebook sign-in failed. Please try again.",
    "auth.noAccount": "Don't have an account?",
    "auth.hasAccount": "Already have an account?",
    "auth.or": "or",
    "dash.customer": "My account",
    "dash.partner": "Partner area",
    "dash.admin": "Administration",
    "dash.myShipments": "My shipments to Africa",
    "dash.myQuotes": "My quotes",
    "dash.notifications": "Notifications",
    "dash.newSearch": "New search",
    "dash.noShipments": "No shipments yet.",
    "ship.reference": "Reference",
    "ship.status": "Status",
    "ship.suppliers": "Suppliers",
    "ship.packages": "Parcels received",
    "ship.addSupplier": "Add a supplier",
    "ship.supplierName": "Supplier name",
    "ship.expectedCartons": "Cartons expected",
    "ship.received": "Received",
    "ship.partial": "Partial",
    "ship.pending": "Pending",
    "ship.consolidate": "Consolidate & ship",
    "ship.estimatedPrice": "Estimated price",
    "ship.estimatedNote": "Your final price is confirmed once we've received and checked your goods (actual weight, dimensions, quantity, CBM).",
    "ship.onQuote": "On quote — we'll confirm your final price once your goods have been received and checked at the warehouse.",
    "ship.initialEstimate": "Initial estimate:",
    "ship.afterVerification": "→ final price after checks",
    "ship.finalPrice": "Final price — awaiting your approval",
    "ship.acceptFinal": "ACCEPT FINAL PRICE",
    "ship.tracking": "Shipment tracking",
    "ship.receivingAddress": "Receiving address",
    "ship.destination": "Destination",
    "ship.mode": "Mode",
    "ship.leaveReview": "Leave a review",
    "ship.cartons": "cartons",
    "partner.dash.newPackages": "Goods in",
    "partner.dash.shipments": "Shipments",
    "partner.dash.routes": "Routes & rates",
    "partner.dash.quotes": "Quotes",
    "partner.dash.profile": "Profile",
    "partner.dash.receive": "Receive a parcel",
    "partner.dash.scan": "Scan / reference",
    "partner.dash.weight": "Weight (kg)",
    "partner.dash.dims": "Dimensions (cm)",
    "partner.dash.cartonsCount": "Number of cartons",
    "partner.dash.setFinal": "Calculate final price",
    "partner.dash.markShipped": "Mark as shipped",
    "partner.dash.markArrived": "Mark as arrived",
    "partner.dash.markDelivered": "Mark as delivered",
    "admin.stats": "Statistics",
    "admin.partners": "Partners",
    "admin.users": "Users",
    "admin.shipments": "Shipments",
    "admin.geo": "Countries & cities",
    "admin.verify": "Verify",
    "admin.unverify": "Remove verification",
    "admin.gmv": "Total volume (GMV)",
    "admin.commission": "Estimated commission",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.add": "Add",
    "common.send": "Send",
    "common.close": "Close",
    "common.loading": "Loading…",
    "common.back": "Back",
    "protected.title": "Payment protection",
    "protected.desc": "Pay for your shipment on the platform. Payments and payouts are released as each verified step of your shipment is completed.",
    "pay.now": "Pay now",
    "pay.paid": "Payment confirmed",
    "pay.protectedNote": "Payment protection: funds are released to the partner in stages (30% on receipt, 60% on departure, 10% on delivery).",
    "pay.awaiting": "Awaiting customer payment",
    "pay.checking": "Checking your payment…",
    "pay.successTitle": "Payment confirmed",
    "pay.successDesc": "Your payment is held securely on the platform. The partner has been notified and your shipment is on its way.",
    "pay.errorTitle": "Payment not confirmed",
    "pay.errorDesc": "Your payment didn't go through. You can try again from your shipment page.",
    "pay.timeoutDesc": "Verification is taking a little longer than usual. Please check your dashboard again in a few minutes.",
    "pay.cancelTitle": "Payment cancelled",
    "pay.cancelDesc": "You haven't been charged. You can restart the payment whenever you're ready.",
    "pay.backDash": "Back to dashboard",
    "pay.pendingBadge": "Payment pending",
    "pay.cancelledBadge": "Payment cancelled",
    "pay.refundedBadge": "Payment refunded",
    "pay.cardBtn": "Pay by card — secure link",
    "pay.manualNote": "Colis2Go will send you a secure card payment link, or Orange Money instructions (Guinea / Ivory Coast).",
    "partner.dash.earnings": "Earnings",
    "earn.total": "Total payouts (payment protection)",
    "earn.released": "Released",
    "earn.pending": "Awaiting milestone",
    "earn.none": "No payouts yet. Your earnings will appear here once the customer has paid.",
    "mobile.search": "Search",
    "mobile.shipments": "Shipments",
    "mobile.quotes": "Quotes",
    "mobile.receive": "Goods in",
    "mobile.earnings": "Earnings",
    "mobile.profile": "Profile",
    "scan.open": "Scan",
    "scan.title": "Scan the QR code",
    "scan.hint": "Hold the shipment's QR code inside the frame.",
    "scan.cameraError": "Camera unavailable. Please allow camera access or select the reference manually.",
    "auth.phone": "Phone (with country code)",
    "auth.country": "Country of residence",
    "auth.city": "City",
    "auth.company": "Company name",
    "auth.depotCountry": "Warehouse country",
    "auth.depotCity": "Warehouse city",
    "auth.address": "Receiving address (warehouse)",
    "auth.addressHint": "Optional at sign-up — you can complete it later in your profile. Only shared with customers after they book.",
    "route.tiers": "Price bands",
    "route.addTier": "Add a band",
    "route.tiersRequired": "Add at least one price band",
    "route.from": "From",
    "route.to": "to (0 = no limit)",
    "route.price": "Price",
    "route.minBillable": "Minimum chargeable weight (kg)",
    "route.volDivisor": "Volumetric divisor",
    "route.specialSurcharge": "Special goods surcharge (€)",
    "route.deliverySurcharge": "Delivery surcharge (€)",
    "route.destFees": "Destination charges (€)",
    "route.minCbm": "Minimum CBM",
    "route.docFees": "Documentation fees (€)",
    "route.customsFees": "Customs clearance (€)",
    "route.palletPrice": "Price per pallet (€)",
    "route.cartonPrice": "Price per carton (€)",
    "profile.phone": "Phone",
    "profile.logo": "Logo (URL)",
    "profile.specialConditions": "Special terms",
    "profile.customsIncluded": "Customs clearance included",
    "profile.deliveryIncluded": "Final delivery included",
    "partner.conditions": "Special terms",
    "trust.title": "Platform Protection",
    "trust.desc": "Verified partners, recorded prices, photos, actual weighing, tracking and proof at every step of your shipment.",
    "mobile.home": "Home",
    "mobile.packages": "Parcels",
    "mobile.more": "More",
    "mobile.suppliers": "Suppliers",
    "mobile.favorites": "Favourites",
    "mobile.support": "Support",
    // --- Landing ---
    "landing.card1.title": "I already have my goods",
    "landing.card1.desc": "Goods in the UK, Europe, the USA or China? Send them to your Colis2Go hub and we'll ship them to Africa for you.",
    "landing.card1.cta": "Ship my goods",
    "landing.card1.estimate": "Estimate by item",
    "landing.card2.title": "I want to shop online",
    "landing.card2.desc": "Get a local address, shop online as usual, then ship everything on to your destination.",
    "landing.card2.cta": "Online shopping",
    "landing.step1.title": "Compare",
    "landing.step1.desc": "Origin to destination, by air or sea.",
    "landing.step2.title": "Book",
    "landing.step2.desc": "Unique code, QR and warehouse address.",
    "landing.step3.title": "Consolidate",
    "landing.step3.desc": "Multiple suppliers, one single shipment.",
    "landing.step4.title": "Track",
    "landing.step4.desc": "Photos, weight, CBM and tracking all the way to arrival.",
    "landing.airDesc": "Priced per kg, chargeable weight, frequent departures.",
    "landing.seaDesc": "Priced per CBM, container groupage, great value.",
    "landing.consoTitle": "Consolidation",
    "landing.consoDesc": "Goods from several suppliers received at one warehouse.",
    // --- Online shopping ---
    "ss.badge": "Online shopping",
    "ss.title": "I want to shop online",
    "ss.subtitle": "Tell us where you're shopping and we'll give you the right Colis2Go address. We receive your parcels, group them together and ship them to your destination.",
    "ss.step1": "1. Where would you like to shop?",
    "ss.step2": "2. Your Colis2Go address",
    "ss.loginPrompt": "Log in to get your personal address and customer code.",
    "ss.loginBtn": "Log in",
    "ss.customersOnly": "Available to customer accounts only.",
    "ss.clientCode": "Your customer code:",
    "ss.copyAddress": "Copy my address",
    "ss.copyInstructions": "Copy the instructions",
    "ss.step3": "3. My purchase batch",
    "ss.step4Customer": "4. Do your shopping",
    "ss.step3Guest": "3. Do your shopping",
    "ss.declared": "I've placed my order",
    "ss.visit": "Visit the store",
    "ss.noShops": "No stores in this category.",
    "ss.unlistedQ": "Can't find your store?",
    "ss.unlistedBtn": "USE ANOTHER STORE",
    "ss.disclaimer": "Colis2Go is not affiliated with any of these brands. The buttons open their official websites.",
    "ss.followTitle": "Track your orders in \"My purchases\"",
    "ss.followDesc": "Declare each order so the warehouse expects it, then consolidate and ship.",
    "ss.myPurchases": "My purchases",
    "ss.catAll": "All",
    // --- Existing goods ---
    "goods.badge": "I already have my goods",
    "goods.title": "Ship your goods to Africa",
    "goods.subtitle": "Wherever they are — the UK, Europe, the USA, China and beyond — send them to your Colis2Go address. We receive them, check them and ship them to Conakry or Abidjan.",
    "goods.step1": "1. Where are your goods right now?",
    "goods.step2": "2. Your Colis2Go hub",
    "goods.multiHub": "Several hubs are available — pick whichever suits you best.",
    "goods.noHub": "No active hub in this country at the moment.",
    "goods.addrLater": "You'll receive the hub's full address as soon as your shipment is created.",
    "goods.step3": "3. Final destination",
    "goods.destCountry": "Destination country",
    "goods.destCity": "City",
    "goods.step4": "4. Your goods",
    "goods.searchPh": "Search: TV, drum, carton, suitcase…",
    "goods.notInCatalog": "We don't have this item in our catalogue yet.",
    "goods.addCustom": "Add my item",
    "goods.yourShipment": "Your shipment",
    "goods.emptyCart": "No items yet. Search above or enter an estimated weight.",
    "goods.weight": "Estimated weight (kg, optional)",
    "goods.estimateBtn": "Get an estimate",
    "goods.estimatePrefix": "Estimated price:",
    "goods.estimateNote": "This estimate is based on the declared information and may be adjusted after your goods are checked at the hub.",
    "goods.quoteOnly": "On quote — we'll confirm your final price once your goods have been received and checked at the hub. We never guess a price.",
    "goods.onQuoteShort": "item(s) on quote",
    "goods.customTitle": "Add my item",
    "goods.customDesc2": "Unlisted item. The amount will be verified by Colis2Go after reception.",
    "goods.customName": "Item name",
    "goods.customQty": "Quantity",
    "goods.customWeight": "Estimated weight (kg)",
    "goods.customDescLabel": "Description",
    "goods.customSubmit": "Add to my shipment",
    "common.onQuote": "On quote",

    "goods.sendTo": "Sending to",
    "goods.ready": "Ready?",
    "goods.readyDesc": "You'll get a unique reference and the hub's full address straight away. Colis2Go then handles transport all the way to",
    "goods.submit": "Create my shipment",
    "goods.loginToContinue": "Log in to continue",
    "goods.creating": "Creating…",
    // --- Purchase batch ---
    "lot.title": "My current purchases",
    "lot.prefQ": "How would you like your purchases shipped? (just a preference — you can change it until consolidation begins)",
    "lot.prefGroup": "Group my purchases",
    "lot.prefSeparate": "Ship separately",
    "lot.prefLater": "I'll decide later",
    "lot.stOpen": "Open",
    "lot.stFinishing": "Waiting for parcels",
    "lot.stReady": "All parcels in — your choice",
    "lot.stToConsolidate": "Being consolidated (warehouse)",
    "lot.stToPrepare": "Being prepared separately (warehouse)",
    "lot.stConsolidated": "Consolidation complete",
    "lot.stPrepared": "Parcels ready",
    "lot.stClosed": "Closed",
    "lot.counter": "{t} purchase(s) · {r} of {t} received",
    "lot.empty": "No purchases in this batch yet.",
    "lot.itemReceived": "Received",
    "lot.itemInTransit": "On its way",
    "lot.itemExpected": "Expected",
    "lot.waiting": "{r} of {t} parcels received. We're still waiting for:",
    "lot.readyQ": "All your parcels have arrived — how would you like them shipped?",
    "lot.toConsolidateInfo": "Consolidation is under way at the Colis2Go warehouse — we'll notify you as soon as it's done.",
    "lot.toPrepareInfo": "Your parcels will be prepared and shipped separately by the warehouse.",
    "lot.doneNext": "Start the shipment from \"My purchases\". Any new purchase will start a new batch.",
    "lot.addPurchase": "Add another purchase",
    "lot.finish": "I've finished shopping",
    "lot.reopen": "Reopen the batch",
    "lot.attach": "Add to batch",
    "lot.outside": "(not in a batch)",
    "lot.created": "Purchase batch created",
    "lot.attached": "Purchase added to the batch",
    // --- WhatsApp ---
    "wa.cta": "CHAT WITH COLIS2GO ON WHATSAPP",
    "wa.msgRef": "Hello Colis2Go, I have a question about my shipment {ref}.",
    "wa.msg": "Hello Colis2Go, I have a question.",
    "auth.backHome": "Back to home",
    "auth.forgot": "Forgot your password?",
    "auth.pwdMin": "At least 8 characters.",
    "auth.connected": "Logged in",
    "auth.accountCreated": "Account created — please verify your email address",
    "otp.enter6": "Enter the 6-digit code",
    "otp.invalid": "Invalid or expired code",
    "otp.resent": "New code sent",
    "otp.wait": "Please wait before resending",
    "otp.verifyTitle": "Verify your email address",
    "otp.sub1": "We've sent a 6-digit code to",
    "otp.sub2": ". It expires in 10 minutes.",
    "otp.verifyBtn": "Verify my email",
    "otp.resend": "Resend code",
    "otp.editEmail": "Change my email address",
    "otp.newEmail": "New email address",
    "otp.updateResend": "Update and resend",
    "otp.already": "Already verified?",
    "otp.verified": "Email address verified — your account is now active",
    "otp.sentTo": "Code sent to",
    "fp.title": "Recover my account",
    "fp.sub1": "Enter your account email — we'll send you a security code.",
    "fp.enterEmail": "Please enter your email",
    "fp.newPwd": "New password",
    "fp.confirmPwd": "Confirm new password",
    "fp.pwdMin8": "At least 8 characters",
    "fp.pwdMismatch": "Passwords don't match",
    "est.title": "What are you sending?",
    "est.subtitle": "Tell us what you're sending to get an estimate.",
    "est.originPh": "Country of origin",
    "est.destPh": "Destination country",
    "est.allModes": "All modes",
    "est.searchPh": "Search for an item: TV, drum, carton 28, Ghana Must Go…",
    "est.cta": "GET AN ESTIMATE",
    "est.verified": "Verified",
    "est.battery": "Battery",
    "est.customDesc": "Unlisted item: it will be confirmed by quote after checks.",
    "dash.home": "Home",
    "dash.purchases": "My online purchases",
    "dash.purchasesSub": "What you have ordered online.",
    "dash.packagesSub": "Your parcels received at Colis2Go and their progress until delivery.",
    "dash.shipmentsSub": "Track your goods ready or shipped to their destination.",
    "st.inTransit": "In transit",
    "prep.title": "Prepare my shipment",
    "prep.pick": "Select the parcels you would like to process together.",
    "prep.received": "Received",
    "prep.expected": "Expected",
    "prep.none": "No received parcels available yet.",
    "prep.qOne": "What would you like to do?",
    "prep.send": "Send this parcel",
    "prep.qMany": "How would you like to prepare these parcels?",
    "prep.group": "Group my parcels",
    "prep.separate": "Keep my parcels separate",
    "prep.wait": "Wait for more",
    "prep.sent": "All noted — Colis2Go is preparing your shipment.",
    "prep.waiting": "All noted — we are waiting for your remaining parcels first.",
    "st.available": "Ready for collection",
    "dash.packages": "My parcels",
    "dash.addresses": "My addresses",
    "dash.suppliers": "Suppliers",
    "dash.support": "Support",
    "st.created": "Created",
    "st.receiving": "Receiving",
    "st.consolidated": "Consolidated",
    "st.paid_pending": "Price accepted — awaiting payment",
    "st.paid": "Ready for departure",
    "st.shipped": "Shipped",
    "st.arrived": "Arrived",
    "st.delivered": "Delivered",
    "ps.announced": "Order declared / parcel expected",
    "ps.in_transit": "On its way",
    "ps.partial": "Partially received",
    "ps.received": "Received",
    "ps.unannounced": "Unannounced parcel",
    "ps2.declared": "Purchase declared",
    "ps2.expected": "Parcel expected",
    "ps2.received": "Parcel received",
    "fp.title": "Your invoice is available",
    "fp.air": "Air / Express",
    "fp.sea": "Sea",
    "fp.accept": "Accept the price",
    "fp.question": "I have a question",
    "fp.accepted": "Price accepted — your file moves to payment.",
    "ps.consolidated": "Consolidated / shipped",
    "ps.rejected": "Rejected",
    "ssx.myTitle": "My online purchases",
    "ssx.consolidateSel": "Consolidate these parcels",
    "ssx.markTransit": "Mark as on its way",
    "ssx.notMine": "This isn't my parcel",
    "ssx.viewShipment": "View shipment",
    "ssx.details": "View details",
    "ssx.prepTitle": "Prepare my shipment",
    "ssx.addrTitle": "My online shopping addresses",
    "ssx.copied": "Address copied",
    "ssx.selHint": "Tick the received purchases you'd like to group, or wait for more parcels — you're never obliged to ship straight away.",
    "ssd.title": "Declare my order",
    "ssd.shop": "Store",
    "ssd.order": "Order number",
    "ssd.tracking": "Tracking (optional)",
    "ssd.expected": "Parcels expected",
    "ssd.value": "Value (optional)",
    "ssd.dest": "Final destination",
    "ssd.chooseDest": "Choose a destination",
    "ssd.desc": "Goods description",
    "ssd.notes": "Notes",
    "ssd.submit": "Declare",
    "unl.title": "Use another store",
    "unl.desc": "Just tell us the name — no need to know the website. We'll find it for you.",
    "unl.search": "Search",
    "unl.searching": "Searching…",
    "unl.useThis": "USE THIS STORE",
    "unl.noUrl": "CONTINUE WITHOUT URL",
    "unl.inCatalog": "already in our catalogue",
    "unl.found": "official website found",
    "goods.routeMsg": "For these goods, send your parcel to your Colis2Go {label} address.",
    "goods.chainCheck": "Receipt & checks",
    "goods.chainShip": "Shipping to Africa",
    "ss.routeMsg": "Shopping in {c}? Use your Colis2Go {label} address.",
    "sd.totalEst": "Estimated total",
    "sd.indicative": "Estimated price — final price after your goods are received and checked.",
    "sd.adjusted": "Price adjusted after checks",
    "sd.confirmed": "Confirmed",
    "sd.awaitingDepot": "Awaiting receipt at the warehouse.",
    "sd.consolidateBtn": "Consolidate my parcels, then ship",
    "sd.shipAsIs": "Ship as is",
    "sd.collectedBy": "Collected by",
    "sd.declare": "Declare a purchase",
    "sd.report": "Report an issue",
    "cat.Toutes": "All",
    "cat.Mode": "Fashion",
    "cat.Électronique": "Electronics",
    "cat.Beauté": "Beauty",
    "cat.Maison": "Home",
    "cat.Sport": "Sport",
    "cat.Marketplace": "Marketplace",
    "cat.Autres": "Other",
    "ctry.Royaume-Uni": "United Kingdom",
    "ctry.France": "France",
    "ctry.Allemagne": "Germany",
    "ctry.Espagne": "Spain",
    "ctry.Belgique": "Belgium",
    "ctry.Italie": "Italy",
    "ctry.Pays-Bas": "Netherlands",
    "ctry.USA": "USA",
    "ctry.Chine": "China",
    "ctry.Turquie": "Turkey",
    "ctry.Émirats (Dubaï)": "UAE (Dubai)",
    "ctry.Autre pays": "Other country",
    "geo.searchCountry": "Search for your country",
    "goods.tracking": "Tracking number (optional)",
    "holder.q": "Who currently has your goods?",
    "holder.supplier": "My supplier / seller",
    "holder.relative": "A relative / friend / family member",
    "holder.self": "Myself",
    "goods.instrSupplier": "Instructions for my supplier",
    "goods.instrRelative": "Instructions for the person sending me the parcel",
    "goods.instrSelf": "Your Colis2Go address",
    "goods.instrSend": "Send the goods to:",
    "goods.instrRef": "Reference to quote:",
    "goods.instrDest": "Final destination:",
    "goods.instrMode": "Mode:",
    "goods.instrTrack": "Please provide the shipment tracking number.",
    "goods.copy": "Copy",
    "goods.share": "Share",
    "goods.viewShipment": "View my shipment",
    "goods.copied": "Instructions copied",
    "goods.holderFirst": "Please tell us first who has your goods.",
    "proh.link": "prohibited / restricted goods list",
    "proh.ack": "I confirm I have read the",
    "proh.title": "Prohibited / restricted goods",
    "nav.how": "How it works",
    "na.title": "Your next action",
    "na.go": "View",
    "na.price": "Your final price is ready ({ref}). View and accept the price.",
    "na.payment": "Your payment is pending ({ref}).",
    "na.choose": "All your parcels have arrived ({ref}). Choose whether to group them.",
    "na.waiting": "We are waiting for your {shop} parcel. No action required.",
    "na.waitingGoods": "We are waiting for your goods ({ref}). No action required.",
    "na.transit": "Your parcel is in transit ({ref}). No action needed.",
    "na.arrived": "Your parcel has arrived in {city} ({ref}). Ready for collection.",
    "na.start": "Get started: shop online or send goods you already have.",
    "na.receivedInfo": "{n} parcel(s) received at Colis2Go. Your invoice is coming shortly.",
    "dash.goods": "I already have my goods",
    "dash.goodsSub": "Goods that you, a relative or a supplier already own.",
    "gd.announced": "Goods announced — instructions available",
    "gd.receiving": "On its way / partially received",
    "gd.received": "Received at Colis2Go",
    "gd.announce": "Announce goods",
    "gd.instructions": "View instructions",
    "gd.none": "No goods announced.",
    "gd.history": "History — received goods",
    "src.online": "Online purchase",
    "src.supplier": "Supplier",
    "src.relative": "Relative / family",
    "src.self": "Myself",
    "src.goods": "Goods",
    "q.purchase": "Question about this purchase",
    "q.goods": "Question about these goods",
    "q.parcel": "Question about this parcel",
    "q.ship": "Question about this shipment",
    "st.ready": "Ready for departure",
    "ship.track": "View tracking",
    "prep.pipeline": "Shipments in preparation",
    "prep.awaitPay": "Invoice accepted — awaiting payment",
    "pk.tracking": "Track your parcels",
    "inv.history": "Payment history",
    "inv.number": "Invoice",
    "inv.ref": "Reference",
    "inv.amount": "Amount",
    "inv.date": "Date",
    "inv.status": "Status",
    "inv.pending": "Pending",
    "inv.toPay": "To pay",
    "inv.initial": "Initial invoice",
    "inv.paid": "Paid",
    "inv.refunded": "Refunded",
    "inv.cancelled": "Cancelled",
    "cx.cancel": "Cancel",
    "cx.title": "Cancellation",
    "cx.fee": "Processing fee",
    "cx.confirm": "Confirm cancellation",
    "cx.keep": "Keep my file",
    "cx.done": "Cancellation confirmed",
    "vf.banner": "Your email address is not verified yet — email is our main notification channel.",
    "vf.action": "Verify my email",
    "pu.code": "Pickup code",
    "pu.codeHint": "show it at pickup (also sent by email)",
    "pu.person": "Authorized person",
    "pu.nobody": "No one else is authorized to collect this parcel.",
    "pu.setPerson": "Authorize someone else",
    "pu.edit": "Edit",
    "pu.hint": "This person will be able to collect your parcel on your behalf. The pickup code received by email will still be required.",
    "pu.name": "Full name",
    "pu.phone": "Phone",
    "pu.idnum": "ID number (optional)",
    "pu.save": "Save",
    "pu.saved": "Authorized person saved — confirmation sent by email",
    "pu.receipt": "Delivery receipt (PDF)",
    "ci.title": "Destination outside Abidjan",
    "ci.body": "Your parcel will first arrive in Abidjan. Additional fees may apply for onward delivery to your final city. Colis2Go will communicate the amount if necessary.",
    "dc.warnTitle": "Destination outside",
    "dc.warnBody1": "Your parcel will first arrive in",
    "dc.warnBody2": "Additional fees may apply for onward delivery to your final city. Colis2Go will communicate the amount if necessary.",
    "dc.arrival": "Destination city *",
    "dc.unavailable": "This city is currently unavailable.",
    "est.modeIncompatible": "This item is not available with this transport mode. Please choose another item.",
    "md.mode": "Transport mode *",
    "md.noDep": "No departure scheduled yet. You can continue your shipment. The departure will be assigned later by Colis2Go.",
    "md.nextDep": "Next planned departure",
    "md.indicative": "Indicative departure. The final voyage will be confirmed once your goods are received at the Hub and the departure is closed.",
    "md.assignAfter": "Your parcel will be assigned to a departure after it is received at the Colis2Go Hub.",
    "pk.enroute": "On its way",
    "pk.departure": "Planned departure:",
    "pk.request": "I have a special request",
    "pk.dep": "Departure:",
    "ssd.departure": "Preferred departure (optional)",
    "ssd.chooseDep": "— Select a departure date —",
    "ssd.noDep": "No departure planned yet — Colis2Go will inform you",
    "ssd.cutoff": "cutoff",
    "sst.edit": "Edit",
    "sst.editTitle": "Edit my declaration",
    "sst.editDesc": "Editable until the parcel is received at Colis2Go.",
    "sst.editOk": "Declaration updated",
    "sst.editSave": "Save",
    "na.receivedInfo": "{n} parcel(s) received at Colis2Go. Your invoice is coming shortly.",
    "ai.q": "What would you like to buy?",
    "ai.ph": "E.g.: Nike sneakers, an evening dress, a phone…",
    "ai.btn": "Suggest shops",
    "ai.busy": "Thinking…",
    "ai.understood": "Understood as",
    "dashx.hello": "Hello {name}",
    "dashx.whatDo": "What would you like to do?",
    "dashx.buyOnline": "I want to shop online",
    "dashx.buyOnlineD": "Get your Colis2Go address and shop in Europe, the UK or beyond.",
    "dashx.haveGoods": "I already have my goods",
    "dashx.haveGoodsD": "Send us goods that you, a relative or your supplier already have.",
    "dashx.myPackages": "My parcels at Colis2Go",
    "dashx.myShipments": "My shipments to Africa",
    "dashx.how": "How it works",
    "dashx.help": "Need help? WhatsApp",
    "hiw.title": "How it works",
    "hiw.v1": "Shopping online with Colis2Go",
    "hiw.v1d": "Get your Colis2Go address, shop at your favourite stores and declare your purchases.",
    "hiw.v2": "I already have my goods",
    "hiw.v2d": "Your supplier, a relative or you yourself send the goods to your Colis2Go hub.",
    "hiw.v3": "After arrival: consolidation, price, payment, shipping",
    "hiw.v3d": "We receive your parcels, group them if you wish, then you pay and track your shipment.",
    "hiw.soon": "Video coming soon",
    "hiw.faqTitle": "Frequently asked questions",
    "hiw.q1": "How do I get my Colis2Go address?",
    "hiw.a1": "Click \"I want to shop online\" and choose the country you are shopping in: we automatically assign your France or UK address with your C2G code.",
    "hiw.q2": "Can I group several purchases?",
    "hiw.a2": "Yes. Declare each purchase in your batch, then choose \"Group my purchases\". We consolidate your parcels at the warehouse to reduce cost.",
    "hiw.q3": "When do I pay?",
    "hiw.a3": "Once everything has arrived (and been consolidated if requested), we send you the final price. You accept it, then pay via Stripe link or Orange Money.",
    "hiw.ctaShop": "I want to shop online",
    "hiw.ctaGoods": "I already have my goods",
    "geo.noResult": "No country found",
    "customs.title": "Customs information",
    "customs.p1": "Before sending your goods to your Colis2Go UK address, please check with the seller or supplier whether any customs duties, import taxes or clearance fees may apply on arrival.",
    "customs.p2": "Some sellers or marketplaces may already include these charges in their delivery terms, while others may charge them separately.",
    "customs.p3": "Colis2Go does not calculate or guarantee these charges. Any import-related charges incurred before the goods reach Colis2Go remain the customer's responsibility.",
    "customs.ack": "I understand.",
    "customs.continue": "Continue",
    "qa.declare": "Declare a purchase",
    "qa.myShipments": "My shipments",
    "qa.track": "Track a shipment",
    "qa.noDeclared": "No purchases declared yet. Use \"Declare a purchase\" to announce incoming goods.",
    "qa.receivedAtDepot": "Parcels received at the warehouse",
    "qa.noneReceived": "No parcels received yet.",
    "qa.delay": "Transit time:",
    "qa.supportHint": "To report an issue with a shipment (missing parcel, disputed weight, damage, delay…), open the shipment page and click \"Report an issue\".",
    "qa.resolution": "Resolution:",
    "qa.fromPrice": "from",
    "dp.title": "Declare a purchase / expected parcel",
    "dp.desc": "Let the warehouse know which goods are on their way.",
    "dp.shipment": "Related shipment",
    "dp.choose": "Choose a shipment",
    "dp.weightEst": "Estimated weight (kg)",
    "dp.value": "Declared value (€)",
    "sst.completeTitle": "Complete the details",
    "sst.completeDesc": "Confirm this parcel by adding the store and order details.",
    "sst.quoteNote": "On quote — your final price will be confirmed once received and checked.",
    "sst.tel": "Tel:",
    "hub.addr": "Address",
    "hub.city": "City",
    "hub.postal": "Postal code",
    "hub.country": "Country",
    "hub.phone": "Phone",
    "hub.hours": "Hours",
    "sst.noAddress": "No address activated yet. Pick a country in \"Online shopping\".",
    "ss.copiedAddr": "Address copied — paste it at the online store checkout",
    "ss.copiedInstr": "Instructions copied",
    "unl.noneFound": "No reliable website found — you can carry on and our team will complete the store's address.",
    "ssd.recvDesc": "Receiving address: {c}. The warehouse will see this parcel under \"Expected parcels\".",
    "fp.sub2a": "Enter the code sent to",
    "fp.sub2b": ". It expires in 10 minutes.",
    "fp.smsLater": "SMS recovery will be available once your phone is verified and the SMS service enabled.",
    "fp.backLogin": "Back to log in",
    "sup.title": "New supplier",
    "sup.desc": "Save your suppliers to reuse them in your declarations.",
    "sup.phone": "Phone",
    "sup.none": "No suppliers saved yet.",
    "prof.country": "Country of residence",
    "prof.lang": "Preferred language",
    "prof.currency": "Preferred currency",
    "prof.addrLabel": "Label (Home, Office…)",
    "sd.copyInstr2": "Instructions copied — paste them into WhatsApp, Alibaba or an email",
    "sd.addSuppliers": "Add your suppliers and share the address and reference with them.",
    "sd.hubWait": "Awaiting your goods at the hub. Share the address and reference with your suppliers.",
    "sd.hubArrived": "Your parcels have arrived at the hub. What would you like to do? Consolidation is never compulsory.",
    "sd.declDesc": "The warehouse will see this parcel under \"Expected parcels\".",
    "sd.reviewDesc": "Rate each aspect from 1 to 5 stars.",
    "sd.noMessages": "No messages. Important exchanges stay attached to the file.",
    "sd.disputeDesc": "A dispute file will be visible to the Colis2Go team.",
    "sd.issueType": "Issue type",
    "ssd.destPh": "Guinea, Ivory Coast…",
    "est.cartTitle": "Your shipment",
    "est.cartEmpty": "No items yet. Search above or add a weight in kg.",
    "est.smallParcel": "Small parcel (kg, optional)",
    "est.calc": "Calculating…",
    "est.batteryWarn": "· Battery / transport approval required",
    "est.viaHub": "Collected via Colis2Go hub",
    "est.days": "days",
    "est.destFees": "Destination charges",
    "est.approval": "Approval required",
    "est.book": "Book",
    "est.nameReq": "Item name required",
    "est.addedUnlisted": "Item added — \"unlisted\", confirmed by quote",
    "est.chooseOD": "Please choose origin and destination",
    "est.addOne": "Add at least one item or a weight",
    "est.noOffer": "No offers on this corridor — try another mode or request a quote",
    "est.custOnly": "Please log in as a customer",
    "est.created": "Shipment {ref} created",
    "est.bookErr": "Booking error",
    "est.quoteSent": "Quote request sent",
    "sst.myParcel": "This is my parcel",
    "sst.confirmMine": "Confirm — this is my parcel",
    "sst.confirmed": "Parcel confirmed",
    "sst.rejected": "Parcel rejected",
    "sst.err": "Error",
    "sst.noDeclared": "No purchases declared yet. Go to \"Online shopping\" then \"I've placed my order\".",
    "sst.addCountry": "Add a country",
    "sst.myAddr": "My address",
    "sst.copy": "Copy",
    "sst.hours": "Opening hours",
    "sst.destReq": "Destination required",
    "sst.consoOk": "Consolidation requested — shipment {ref} created",
    "sst.cityOpt": "City (optional)",
    "sst.selCount": "purchase(s) selected",
    "qa.resolved": "Resolved",
    "qs.accepted": "Accepted",
    "qs.refused": "Declined",
    "ps.to_wh": "On its way to the warehouse",
    "ctry.Guinée": "Guinea",
    "ctry.Côte d'Ivoire": "Ivory Coast",

  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "fr");
  const t = useCallback((key) => (DICT[lang] && DICT[lang][key]) || (DICT.fr[key]) || key, [lang]);
  const change = useCallback((l) => { setLang(l); localStorage.setItem("lang", l); }, []);
  return <I18nContext.Provider value={{ lang, t, setLang: change }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
